import React from 'react';
import { Reveal } from '../ui/Reveal';
import { JobCard } from '../ui/JobCard';
import { JOBS } from '../../data/jobs';

export const Jobs = ({ onJobClick }) => {
  return (
    <section className="sec" id="build-with-us">
      <Reveal><div className="slabel">Collab</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">Build with <em>us</em></h2></Reveal>
      <Reveal delay="1">
        <p className="jobs-intro">
          We're deep into bigger projects right now and <strong>can't give smaller ones the time they deserve.</strong> Rather than turning them away, we're passing them to people we trust.
          You get real client work, we keep things moving. <strong>Not a job</strong> — no fixed hours, no guaranteed work, no monthly pay. We reach out when something fits your stack, could be next week, could be two months from now. You build it, we handle the client. You keep <strong>80%</strong> — the 20% we retain covers domains, deployment, hosting and infra on our end.
        </p>
      </Reveal>

      <div className="jobs-grid">
        {JOBS.map((job, i) => (
          <Reveal key={job.id} delay={((i % 2) + 1).toString()}>
            <JobCard job={job} onClick={onJobClick} />
          </Reveal>
        ))}
      </div>

      <Reveal delay="2">
        <div className="jobs-note">
          <div className="jobs-note-icon">⚠️</div>
          <div className="jobs-note-text">
            <strong>Be clear about what this is:</strong> There's no schedule, no retainer, no guarantee of work.
            We reach out when something comes in. You're free to say no.
            The 20% we retain covers domains, deployment, hosting, SSL, and any infra costs we pay upfront for the project.
            Think of it as a side hustle — not a salary.
          </div>
        </div>
      </Reveal>
    </section>
  );
};